require('./HistoryModalDescription.scss');
const React = require('react');
const DateUtils = require('utils/DateUtils'),
{t} = require('services/i18nextWrapper');

const HistoryModalDescription = React.createClass({displayName: "HistoryModalDescription",
    render(){
        const {history, selectedModule} = this.props;
        return (
            React.createElement("div", null, 
                React.createElement("dl", {className: "bp-history-modal-description"}, 
                    React.createElement("div", {className: "bp-history-modal-description__field"}, 
                        React.createElement("dt", {className: "bp-history-modal-description__field-column-name"}, t('history_modal_description_change_date')), 
                        React.createElement("dd", {className: "bp-history-modal-description__field-value"}, DateUtils.toYYYYMMDDhhmm(history.date))
                    ), 
                    React.createElement("div", {className: "bp-history-modal-description__field"}, 
                        React.createElement("dt", {className: "bp-history-modal-description__field-column-name"}, t('history_modal_description_type_operation')), 
                        React.createElement("dd", {className: "bp-history-modal-description__field-value"}, history.type)
                    ), 
                    React.createElement("div", {className: "bp-history-modal-description__field"}, 
                        React.createElement("dt", {className: "bp-history-modal-description__field-column-name"}, t('history_modal_description_user:')), 
                        React.createElement("dd", {className: "bp-history-modal-description__field-value"}, history.userName)
                    ), 
                    React.createElement("div", {className: "bp-history-modal-description__field"}, 
                        React.createElement("dt", {className: "bp-history-modal-description__field-column-name"}, t('history_modal_description_module:')), 
                        React.createElement("dd", {className: "bp-history-modal-description__field-value"}, selectedModule.displayName)
                    )
                )
            )
        );
    }
});


module.exports = HistoryModalDescription;



/** WEBPACK FOOTER **
 ** ./src/views/HistoryAdmin/HistoryModal/HistoryModalDescription.jsx
 **/